import {
  getIntegrationIcon,
  getIntegrationTextContent,
} from 'constants/integrations';
import React from 'react';
import { ConnectedAccount as ConnectedAccountType } from 'records/ConnectedAccount';
import { useTranslator } from '@bluebeam/react-i18n';

export type Props = {
  account: ConnectedAccountType;
  index: number;
  onClick?: () => void;
  label: string;
  children?: React.ReactNode;
  classes?: string;
};

const ConnectedAccount: React.FC<Props> = ({
  account,
  onClick,
  label,
  children,
  classes,
}: Props) => {
  const provider = getIntegrationTextContent(account.providerType).title;
  const icon = getIntegrationIcon(account.providerType);
  const { translate } = useTranslator(['integrationsPage']);

  return (
    <div
      className={`column bgd-white bb-solid bb-width-2 bb-mid-grey-2 cursor-pointer ${classes}`}
      onClick={onClick}
    >
      <div className="row">
        <div className="p3">
          <img
            className="wrem-2p5 primary-blue"
            src={icon}
            alt="filter filled icon"
          />
        </div>
        <div className={`column justify-center ${children ? 'w80' : 'w100'}`}>
          <div className="font-size-5 primary-blue">{provider}</div>
          {account.isExpired ? (
            <span className="font-size-2" style={{ color: '#a71629' }}>
              {translate(
                'integrationsPage:manageConnectedAccount.expiredConnection'
              )}
            </span>
          ) : (
            <div className="font-size-2 color-gray-7">{label}</div>
          )}
        </div>
        {children ? (
          <div className="column justify-center content-end items-end w20 color-gray-7 p3">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ConnectedAccount;
